
<template>
  <div id="chart3"
       style="width:100%; height: 100%;"></div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ['width', "height", 'data'],
  // data:{name:'标题',  data: [
  //           { value: 335, name: '直接访问' },
  //           { value: 310, name: '邮件营销' },
  //           { value: 234, name: '联盟广告' },
  //           { value: 135, name: '视频广告' },
  //           { value: 1548, name: '搜索引擎' }
  //         ]}

  data () {
    return {
      legendData: [],
    }
  },
  watch: {
    data: {
      handler: function () {
        this.init()
      },
      deep: true    }
  },
  mounted () {
    this.init()
  },
  methods: {
    getLegend () {
      let data = this.data
      data.forEach(item => {
        this.legendData.push(item.name)
      })

    },
    init () {
      this.getLegend()
      let option = {
        tooltip: {//提示框，可以在全局也可以在
          trigger: 'item',  //提示框的样式
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          color: 'rgb(86,136,280)', //提示框的背景色
          textStyle: { //提示的字体样式
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "withe",
          }
        },
        legend: {  //图例
          orient: 'horizontal',  //图例的布局，竖直    horizontal为水平
          x: 'left',//图例显示在右边
          data: this.legendData,
          textStyle: {    //图例文字的样式
            color: '#fff',  //文字颜色
            fontSize: 12 * this.$store.state.ratio.hole,
          }
        },
        series: [
          {
            name: '',
            type: 'pie', //环形图的type和饼图相同
            radius: ['50%', '60%'],//饼图的半径，第一个为内半径，第二个为外半径
            avoidLabelOverlap: false,
            color: ['#4fff5a', '#e03d38', '#4CD0DD', '#DF86F0', '#F5A7C1'],
            label: {
              normal: {  //正常的样式
                show: true,
                position: 'left',
                textStyle: {
                  fontSize: 12 * this.$store.state.ratio.hole,
                  fontWeight: 'bold'
                }
              },
              emphasis: { //选中时候的样式
                show: true,
                textStyle: {
                  fontSize: 20 * this.$store.state.ratio.hole,
                  fontWeight: 'bold'
                }
              }
            },  //提示文字
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.data
          }
        ]
      };

      var myChart = echarts.init(this.$el);
      myChart.getDom().style.height = this.height
      myChart.getDom().style.width = this.width
      myChart.setOption(option);
    }
  }
}
</script>
<style lang="scss" scoped>
canvas {
  height: 100%;
}
div {
  height: 100%;
}
</style>
